export const environment = {
  production: false,
  apiUrl: '/api',
  siteUrl: 'https://staging.dirtrunner.pro',
  appUrl: 'https://app-staging.dirtrunner.pro',
  appName: 'DirtRunner (Staging-test)',
};
